
import PageHead from "@/components/PageHead";
import SafetyWarning from "@/components/SafetyWarning";
import { useTranslation } from "react-i18next";
import Decimal from "decimal.js";
import "./index.less";


import {
  DEFAULT_RPC,
} from "@/config";
import BN from "bn.js";
// import { TickMath, ClmmPoolUtil } from "@cetusprotocol/sui-clmm-sdk";
import { useCurrentAccount, useSignAndExecuteTransaction } from "@mysten/dapp-kit";
import ListModalAntd from "@/components/ListModalAntd";
import { useEffect, useMemo, useState } from "react";
import { Alert, Form, Input, message, Segmented, Select } from "antd";
import PrivateKeyOperate from "./components/PrivateKeyOperate";
import WalletOperate from "./components/WalletOperate";

import { SuiClient, getFullnodeUrl } from "@mysten/sui/client";
import { isValidSuiPrivateKey } from "@/utils/check";
import { formatUnits } from "viem";
import { FEE_ADDRESS } from "@/config/feeAddress";
import { decodeSuiPrivateKey } from '@mysten/sui/cryptography';
import { Ed25519Keypair } from '@mysten/sui/keypairs/ed25519';
import { CetusClmmSDK } from '@cetusprotocol/sui-clmm-sdk';

import { cdnUrl } from "@/utils/cdn";
import MyModal from "./components/MyModal";
import Loader from "@/components/Loader";
import { quoteToken2FromToken1_WithSort, quoteToken2ByToken1_ForAddLiquidity, quoteNeedToken2ForNewPosition, openNewPositionWithFixedToken1 } from "@/utils/cetus";
import { isSuiCoinType } from "@/utils/suiMethods";
import { getPoolsByTwoCoinTypes } from "@/suiService";
const client = new SuiClient({
  url: DEFAULT_RPC,
});
const sdk = CetusClmmSDK.createSDK({ env: "mainnet", full_rpc_url: DEFAULT_RPC });
const serviceFee = FEE_ADDRESS.sui.addLiquidity.serviceFee;
const serviceFeeReciver = FEE_ADDRESS.sui.addLiquidity.serviceFeeReciver;
type CreatePoolParams = {
  env: 'mainnet' | 'testnet';
  rpcUrl: string;
  // suiprivkey...（建议用这个格式）；decodeSuiPrivateKey 可解析并拿到 secretKey bytes :contentReference[oaicite:3]{index=3}
  suiPrivateKey?: string;
  // 你输入的 TokenA / TokenB（coinType）
  tokenA: string;
  tokenB: string;
  // 你输入的初始价格：tokenB per tokenA（1 A = ? B）
  initialPrice: string;
  // tick spacing（决定费率档）:contentReference[oaicite:4]{index=4}
  tickSpacing: number;
  // 你输入的 tokenA 数量（人类单位）
  tokenAAmount: string;
  // 可选：滑点
  slippage?: number;
  // 可选：集中区间（不传则 full range）
  range?: { minPrice: string; maxPrice: string };
};
export default function AddLiquidity() {
  const { t, i18n } = useTranslation();
  const options = useMemo(
    () => [
      {
        label: t("customizedAuthorization.walletOperation"),
        value: "walletOperate",
      },
      {
        label: t("customizedAuthorization.privateKeyOperation"),
        value: "privateKeyOperate",
      },
    ],
    [t]
  );
  const dexOptions = useMemo(
    () => [
      {
        label: <><img style={{ width: "16px" }} src={cdnUrl("/img/sui/cetus.png")} alt="" />cetus</>,
        value: "cetus",
      },
    ],
    [t]
  );
  const account = useCurrentAccount();
  const [form] = Form.useForm();
  const initPrice = Form.useWatch("initPrice", form);
  const token1Amount = Form.useWatch("token1Amount", form);
  const token2Amount = Form.useWatch("token2Amount", form);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const feeRate = Form.useWatch("feeRate", form);
  const [pool, setPool] = useState({});
  const [walletType, setWalletType] = useState("walletOperate");
  const [basicInfo1, setBasicInfo1] = useState<any>({});
  const [basicInfo2, setBasicInfo2] = useState<any>({});
  const [isCreating, setIsCreating] = useState(false)
  const [hash, setHash] = useState("");
  const [dexType, setDexType] = useState("cetus");
  const [privateAddress, setPrivateAddress] = useState("");
  const [privateKey, setPrivateKey] = useState("");
  const [privateKeyBalance, setPrivateKeyBlance] = useState("0")
  const [balance, setBalance] = useState("");
  const { mutateAsync: signAndExecuteTransaction } = useSignAndExecuteTransaction();
  // 创建流动性时请确保钱包有足够的资金，避免添加失败
  const hintMessage = t("createLiquidity.ensureEnoughFunds")
  console.log("basicInfo1", basicInfo1);
  console.log("basicInfo2", basicInfo2)
  const [TickFeeRate, setTickFeeRate] = useState<any>({
    "2": {
      tickSpacing: "2",
      feePeople: "0.01%",
      feeRaw: "100",
      isExiting: false
    },
    "4": {
      tickSpacing: "4",
      feePeople: "0.02%",
      feeRaw: "200",
      isExiting: false
    },
    "6": {
      tickSpacing: "6",
      feePeople: "0.03%",
      feeRaw: "300",
      isExiting: false
    },
    "8": {
      tickSpacing: "8",
      feePeople: "0.04%",
      feeRaw: "400",
      isExiting: false
    },
    "10": {
      tickSpacing: "10",
      feePeople: "0.05%",
      feeRaw: "500",
      isExiting: false
    },
    "20": {
      tickSpacing: "20",
      feePeople: "0.1%",
      feeRaw: "1000",
      isExiting: false
    },
    "30": {
      tickSpacing: "30",
      feePeople: "0.15%",
      feeRaw: "1500",
      isExiting: false
    },
    "40": {
      tickSpacing: "40",
      feePeople: "0.2%",
      feeRaw: "2000",
      isExiting: false
    },
    "60": {
      tickSpacing: "60",
      feePeople: "0.25%",
      feeRaw: "2500",
      isExiting: false
    },
    "80": {
      tickSpacing: "80",
      feePeople: "0.3%",
      feeRaw: "3000",
      isExiting: false
    },
    "100": {
      tickSpacing: "100",
      feePeople: "0.4%",
      feeRaw: "4000",
      isExiting: false
    },
    "120": {
      tickSpacing: "120",
      feePeople: "0.6%",
      feeRaw: "6000",
      isExiting: false
    },
    "160": {
      tickSpacing: "160",
      feePeople: "0.8%",
      feeRaw: "8000",
      isExiting: false
    },
    "200": {
      tickSpacing: "200",
      feePeople: "1%",
      feeRaw: "10000",
      isExiting: false
    },
    "220": {
      tickSpacing: "220",
      feePeople: "2%",
      feeRaw: "20000",
      isExiting: false
    },
    "260": {
      tickSpacing: "260",
      feePeople: "4%",
      feeRaw: "40000",
      isExiting: false
    }
  });

  // poolsRes 是你 axios 返回的 res（也可以直接传 list）
  function syncTickFeeRateWithPools(poolsRes: any) {
    const list =
      poolsRes?.data?.data?.list ??
      poolsRes?.data?.list ??
      poolsRes?.list ??
      [];

    setTickFeeRate((prev) => {
      const next: typeof prev = {} as any;

      // 如果没查到任何池子：全部置为 false
      if (!Array.isArray(list) || list.length === 0) {
        for (const [tickSpacing, item] of Object.entries(prev)) {
          next[tickSpacing] = { ...item, isExiting: false };
        }
        return next;
      }

      const feeSet = new Set<number>(list.map((p: any) => Number(p.feeRate)));

      for (const [tickSpacing, item] of Object.entries(prev)) {
        next[tickSpacing] = {
          ...item,
          // 你原本的逻辑：存在就置 true；这里仍保留“或”逻辑
          isExiting: item.isExiting || feeSet.has(Number(item.feeRaw)),
        };
      }

      return next;
    });
  }

  function priceFromSqrtPriceX64(params: {
    sqrtPriceX64: string; // 例如 "190838625429033635648"
    decimalsA: number;    // USDC 6
    decimalsB: number;    // slf 9
  }) {
    const { sqrtPriceX64, decimalsA, decimalsB } = params;

    const Q64 = new Decimal(2).pow(64);

    // raw: tokenB/tokenA（最小单位比值）
    const priceRaw_BperA = new Decimal(sqrtPriceX64).div(Q64).pow(2);

    // human: tokenB/tokenA（按 decimals 换算）
    const priceHuman_BperA = priceRaw_BperA.mul(
      new Decimal(10).pow(decimalsA - decimalsB)
    );

    // human: tokenA/tokenB
    const priceHuman_AperB = new Decimal(1).div(priceHuman_BperA);

    return {
      priceRaw_BperA: priceRaw_BperA.toString(),
      priceHuman_BperA: priceHuman_BperA.toString(), // 1 A = ? B
      priceHuman_AperB: priceHuman_AperB.toString(), // 1 B = ? A
    };
  }

  // console.log("tickFeeRate", TickFeeRate)
  const listmodal1Custom = useMemo(() => [
    "0x2::sui::SUI",
    "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC",
    "0x375f70cf2ae4c00bf37117d0c85a2c71545e6ee05c4a5c7d282cd66a4504b068::usdt::USDT"
  ], [/* 真正会变化的源 */])
  const filterList = useMemo(() => ["0x2::sui::SUI", "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC", "0x375f70cf2ae4c00bf37117d0c85a2c71545e6ee05c4a5c7d282cd66a4504b068::usdt::USDT"], [/* 真正会变化的源 */]);
  // -----------------------
  // 1) 小工具：coinType 排序（按文档：逐字符 ASCII 比较，较大者为 coin_a）:contentReference[oaicite:2]{index=2}
  // -----------------------
  function sortCoinTypes(coinX: string, coinY: string): { coinTypeA: string; coinTypeB: string } {
    // 这里按 JS 字符串逐字符比较，本质就是字典序（等价于逐字符 ASCII）
    return coinX > coinY ? { coinTypeA: coinX, coinTypeB: coinY } : { coinTypeA: coinY, coinTypeB: coinX };
  }
  // -----------------------
  // 2) 小工具：把 "12.34" 转成 base units（BigInt）
  // -----------------------
  function toBaseUnits(amountHuman: string, decimals: number): bigint {
    const s = amountHuman.trim();
    if (!s) throw new Error('amountHuman empty');

    const [intPartRaw, fracPartRaw = ''] = s.split('.');
    const intPart = intPartRaw === '' ? '0' : intPartRaw;
    const fracPart = fracPartRaw.padEnd(decimals, '0').slice(0, decimals);

    const combined = `${intPart}${fracPart}`.replace(/^0+/, '') || '0';
    return BigInt(combined);
  }
  // -----------------------
  // 3) 小工具：价格取倒数（字符串）
  // -----------------------
  function invertPrice(price: string): string {
    // 简单做法：用 JS number（适合常见价格）；你要更高精度可以换 decimal.js
    const p = Number(price);
    if (!Number.isFinite(p) || p <= 0) throw new Error(`invalid price: ${price}`);
    return String(1 / p);
  }

  function invert(x: string): string {
    // 避免 JS 浮点误差：建议用 decimal.js / big.js
    return (1 / Number(x)).toString();
  }
  // console.log("feeRate", TickFeeRate[feeRate].feeRaw)
  function normalizePriceAndRange(params: {
    tokenA: string;
    tokenB: string;
    coin_type_a: string;
    coin_type_b: string;
    initialPrice: string; // 你输入的：tokenA per tokenB（1 B = ? A）
    range?: { minPrice: string; maxPrice: string };
  }) {
    const { tokenA, tokenB, coin_type_a, coin_type_b, initialPrice, range } = params;

    // 目标口径：price_base_coin = 'coin_b' => current_price = coin_a per coin_b
    let current_price: string;
    let add_mode_params:
      | { is_full_range: true }
      | { is_full_range: false; min_price: string; max_price: string };

    if (tokenA === coin_type_a && tokenB === coin_type_b) {
      // 你输入的是 A per B，刚好等于 coin_a per coin_b
      current_price = initialPrice;

      add_mode_params = range
        ? { is_full_range: false, min_price: range.minPrice, max_price: range.maxPrice }
        : { is_full_range: true };
    } else if (tokenA === coin_type_b && tokenB === coin_type_a) {
      // 你输入的是 B per A，需要反过来得到 A per B
      current_price = invert(initialPrice);

      if (range) {
        // 区间同样要反转并交换上下界
        const min_price = invert(range.maxPrice);
        const max_price = invert(range.minPrice);
        add_mode_params = { is_full_range: false, min_price, max_price };
      } else {
        add_mode_params = { is_full_range: true };
      }
    } else {
      throw new Error("tokenA/tokenB mismatch after sorting");
    }

    // 强校验，避免合约 abort
    if ("min_price" in add_mode_params) {
      const cp = Number(current_price);
      const mn = Number(add_mode_params.min_price);
      const mx = Number(add_mode_params.max_price);
      if (!(mn < cp && cp < mx)) {
        throw new Error(`Invalid range: require min_price < current_price < max_price, got ${mn} < ${cp} < ${mx}`);
      }
    }

    return { current_price, add_mode_params };
  }

  // const getToken2Amount = (position: any) => {
  //   const tick_lower_index = position.tick_lower_index
  //   const tick_upper_index = position.tick_upper_index
  //   const coin_amount = new BN(500)
  //   const fix_amount_a = true
  //   const slippage = 0.1
  //   const cur_sqrt_price = new BN(pool.current_sqrt_price)

  //   const liquidity_input = ClmmPoolUtil.estLiquidityAndCoinAmountFromOneAmounts(
  //     tick_lower_index,
  //     tick_upper_index,
  //     coin_amount,
  //     fix_amount_a,
  //     true,
  //     slippage,
  //     cur_sqrt_price
  //   )

  // }
  function sortTokenInfosByCoinType<T extends { coinType: string }>(
    basicInfo1: T,
    basicInfo2: T
  ): { tokenA: T; tokenB: T; tokenAIsFirst: boolean } {
    const c1 = (basicInfo1?.coinType ?? "").toString();
    const c2 = (basicInfo2?.coinType ?? "").toString();

    if (!c1 || !c2) throw new Error("coinType is required for both tokens");

    if (c1 === c2) {
      return { tokenA: basicInfo1, tokenB: basicInfo2, tokenAIsFirst: true };
    }

    // JS 字符串比较就是逐字符 ASCII 的字典序比较
    const tokenAIsFirst = c1 > c2;

    return tokenAIsFirst
      ? { tokenA: basicInfo1, tokenB: basicInfo2, tokenAIsFirst: true }
      : { tokenA: basicInfo2, tokenB: basicInfo1, tokenAIsFirst: false };
  }

  const getPoolByCoins = async () => {

    const poolsRes = await getPoolsByTwoCoinTypes([basicInfo1.coinType, basicInfo2.coinType])
    syncTickFeeRateWithPools(poolsRes)
    const pools = poolsRes?.data?.data?.list || []
    //如果有当前费率层级和pools算出初始价格

    if (pools.length > 0 && feeRate) {
      // console.log("feeRate", feeRate)
      const poolFeeRate: any = TickFeeRate[feeRate].feeRaw || 0;
      console.log("查出来的feeRate", poolFeeRate)
      //找到池子id
      const poolId = pools.filter((pool: any) => pool.feeRate == poolFeeRate)[0]?.pool || "";
      console.log("poolId", poolId)
      if (!poolId) {
        return
      }
      const pool = await sdk.Pool.getPool(poolId)
      console.log("poolpoolpool", pool)
      const { tokenA, tokenB, tokenAIsFirst } = sortTokenInfosByCoinType(basicInfo1, basicInfo2);
      console.log("tokenA", tokenA);
      console.log("tokenB", tokenB)
      console.log("tokenAIsFirst", tokenAIsFirst)
      const res = priceFromSqrtPriceX64({
        sqrtPriceX64: pool.current_sqrt_price.toString(),
        decimalsA: tokenA.decimals,
        decimalsB: tokenB.decimals
      })
      if (tokenA.coinType == basicInfo1.coinType) {
        form.setFieldValue("initPrice", Number(res.priceHuman_AperB).toFixed(6));
      } else {
        form.setFieldValue("initPrice", Number(res.priceHuman_BperA).toFixed(6))
      }



      setPool(pool);
    } else {
      form.setFieldsValue({
        "initPrice": 0,
        "token1Amount": 0,
        "token2Amount": 0
      })
    }
    console.log("pools", pools)
  }

  useEffect(() => {
    console.log("feeRate", feeRate)
    if (Object.keys(pool).length > 0 && token1Amount && basicInfo1.coinType && basicInfo2.coinType && TickFeeRate[feeRate].isExiting) {
      console.log("里面token1Amount", token1Amount)
      const { tokenA, tokenB } = sortTokenInfosByCoinType(basicInfo1, basicInfo2);
      // ✅ 动态判断 token1 是不是 A

      const out = quoteToken2ByToken1_ForAddLiquidity({
        pool,
        token1AmountHuman: token1Amount,
        decimalsA: tokenA.decimals,
        decimalsB: tokenB.decimals,
        token1IsA: basicInfo1.coinType === pool.coin_type_a,   // USDC 是 A
        rangePct: 0.1,      // ±10%
        slippage: 0.05,    // 0.5%
      });
      console.log("out", out)
      form.setFieldValue("token2Amount", out.needToken2AmountHuman)
    } else {
      form.setFieldValue("tokenAmount2", 0)
    }
  }, [pool, token1Amount])
  const copy = async (content: any) => {
    await navigator.clipboard.writeText(content);
    message.success(t("tips.copy"));
  };
  const formatAddress = (str: string) => {
    if (!str) return
    return `${str.slice(0, 15)}...${str.slice(-15)}`;
  }


  const getBalance = async (isWallet?: Boolean) => {
    const balanceres = await client.getBalance({
      owner: (isWallet ? account?.address : privateAddress) || "",
    })
    if (isWallet) {
      setBalance(balanceres.totalBalance)
    } else {
      setPrivateKeyBlance(balanceres.totalBalance)
    }

    // console.log("balanceres", balanceres)
  }


  // console.log("basicInfo1", basicInfo1)
  // console.log("basicInfo2", basicInfo2)
  const balanceFun1 = () => {
    if (walletType == "walletOperate" && Object.keys(basicInfo1).length > 0) {
      return formatUnits(basicInfo1.totalBalance, basicInfo1.decimals)
    }
    if (walletType == "privateKeyOperate" && Object.keys(basicInfo1).length > 0) {
      return formatUnits(basicInfo1.totalBalance, basicInfo1.decimals)
    }
    return 0
  }
  const balanceFun2 = () => {
    if (walletType == "walletOperate" && Object.keys(basicInfo2).length > 0) {
      return formatUnits(basicInfo2.totalBalance, basicInfo2.decimals)
    }
    if (walletType == "privateKeyOperate" && Object.keys(basicInfo2).length > 0) {
      return formatUnits(basicInfo2.totalBalance, basicInfo2.decimals)
    }
    return 0
  }


  const addressFun = () => {
    if (walletType == "walletOperate" && account) {
      return account.address
    }
    if (walletType == "privateKeyOperate" && privateAddress) {
      return privateAddress
    }
    return ""
  }
  const setToken1Amount = (raito: any) => {
    if (Object.keys(basicInfo1).length == 0) return
    form.setFieldValue("token1Amount", Number(formatUnits(BigInt(basicInfo1.totalBalance) * BigInt(raito) / BigInt(10), basicInfo1.decimals)))
  }
  console.log("pool", pool)
  function alignInfosToPool(pool: any, info1: any, info2: any) {
    const aType = pool.coin_type_a;
    const bType = pool.coin_type_b;

    const infoA = info1.coinType === aType ? info1 : (info2.coinType === aType ? info2 : null);
    const infoB = info1.coinType === bType ? info1 : (info2.coinType === bType ? info2 : null);

    if (!infoA || !infoB) {
      throw new Error("basicInfo1/basicInfo2 与 pool.coin_type_a/b 不匹配");
    }
    return { infoA, infoB }; // 这里的 A/B 一定和 pool 对齐
  }

  const start = async () => {
    if (Object.keys(basicInfo1).length == 0 || Object.keys(basicInfo2).length == 0) {
      message.error(t("createLiquidity.pleaseSelectToken"))
      return
    }
    await form.validateFields()
    try {
      setHash("");
      setIsCreating(true)
      if (walletType == "privateKeyOperate") {
        const decoded = decodeSuiPrivateKey(privateKey);
        if (decoded.schema !== "ED25519") {
          throw new Error(`Unsupported key schema: ${decoded.schema} (expect ED25519)`);
        }
        const keypair = Ed25519Keypair.fromSecretKey(decoded.secretKey);
        const sender = keypair.toSuiAddress();

        // 2) 设置 sender（很重要）
        sdk.setSenderAddress(sender);
        const { payload } = await openNewPositionWithFixedToken1({
          sdk,
          pool: pool as any,
          basicInfo1,
          basicInfo2,
          token1AmountHuman: token1Amount.toString(),
          rangePct: 0.1,
          slippage: 0.005,
        })
        // 有些版本需要显式 setSender（双保险）
        payload.setSender(sender);
        const [feeCoin] = payload.splitCoins(payload.gas, [payload.pure.u64(serviceFee.toString())]);
        payload.transferObjects([feeCoin], payload.pure.address(serviceFeeReciver));
        // 5) build + sign + execute
        const res = await client.signAndExecuteTransaction({
          signer: keypair,
          transaction: payload,
          requestType: "WaitForLocalExecution",
          options: { showEffects: true, showObjectChanges: true, showEvents: true },
        });

        setHash(res.digest);
      }
      // walletOperate
      if (walletType == "walletOperate") {

        sdk.setSenderAddress(account?.address || ""); // ✅ 必须
        const { payload } = await openNewPositionWithFixedToken1({
          sdk,
          pool: pool as any,
          basicInfo1,
          basicInfo2,
          token1AmountHuman: token1Amount.toString(),
          rangePct: 0.1,
          slippage: 0.005,
        })
        const [feeCoin] = payload.splitCoins(payload.gas, [payload.pure.u64(serviceFee.toString())]);
        payload.transferObjects([feeCoin], payload.pure.address(serviceFeeReciver));
        const res = await signAndExecuteTransaction({
          transaction: payload,          // ✅ 直接传 Transaction          
        });
        await client.waitForTransaction({
          digest: res.digest,
          options: { showEffects: true, showObjectChanges: true, showEvents: true },
        });
        setHash(res.digest);
      }
      setIsSuccessModalOpen(true)
    } catch (error) {
      setIsErrorModalOpen(true)
      console.log("error", error)
    } finally {
      setIsCreating(false)
    }
  }
  useEffect(() => {
    if (account) {
      getBalance(true)
    } else {
      setBalance("0")
    }
  }, [account])
  useEffect(() => {
    if (privateKey && isValidSuiPrivateKey(privateKey)) {
      getBalance(false)
    } else {
      setPrivateKeyBlance("0")
    }
  }, [privateKey])

  useEffect(() => {
    if (basicInfo1.coinType && basicInfo2.coinType) {
      getPoolByCoins()
    } else {
      form.setFieldValue("token2Amount", (0));
      form.setFieldValue("initPrice", 0)
      form.setFieldValue("token1Amount", 0)
    }

  }, [basicInfo1.coinType, basicInfo2.coinType, feeRate])

  return (
    <div className="page-content liquidity-wrap">
      {/* {contextHolder} */}
      <PageHead
        title={t("addLiquidity.title")}
        desc={t("addLiquidity.desc", { chain: "SUI", dex: "Cetus" })}
      >
        <SafetyWarning />
      </PageHead>

      <Segmented<string>
        className="segmented-wallet"
        style={{ marginTop: "24px" }}
        options={options}
        value={walletType}
        onChange={(value) => {
          setWalletType(value);
          setPrivateKey("");
          setPrivateAddress("");
        }}
      />
      {walletType == "walletOperate" ? (
        <WalletOperate account={account} balance={balance} />
      ) : (
        <PrivateKeyOperate
          privateKey={privateKey}
          setPrivateKey={setPrivateKey}
          setPrivateAddress={setPrivateAddress}
          privateAddress={privateAddress}
          privateKeyBalance={privateKeyBalance}
        />
      )}
      {/* DEX选择 */}
      <div className="dex-option">{t("createLiquidity.dexSelect")}</div>
      <Segmented<string>
        className="segmented-wallet"
        options={dexOptions}
        value={dexType}
        onChange={(value) => {
          setDexType(value);
        }}
      />
      <div className="select-token-section">
        <div className="input-section">
          {/* 基础代币 */}
          <div className="input-title">{t("createLiquidity.baseToken")}</div>
          <ListModalAntd
            address={addressFun()}
            value="0x2::sui::SUI"
            canClear={false}
            custo
            getSelectedTokenInfo={(value: any) => {

              setBasicInfo1({ ...value })
            }}
            customkenCoinTypeLists={listmodal1Custom}
          >
          </ListModalAntd>
        </div>
        <div className="input-section">
          {/* 报价代币 */}
          <div className="input-title">{t("createLiquidity.quoteToken")}</div>
          <ListModalAntd
            address={addressFun()}
            // 请选择代币
            placeholder={t("createLiquidity.pleaseSelectToken")}
            filterAddrs={filterList}
            getSelectedTokenInfo={(value: any) => {
              setBasicInfo2({ ...value })
            }}
          >
          </ListModalAntd>
        </div>
      </div>

      <Form form={form}>
        <div className="setting-section">
          <div className="row">
            <div className="input-section">
              {/* 初始价格 */}
              <div className="input-title">{"当前价格"}</div>
              {/* 请输入初始价格 */}
              <Form.Item name="initPrice" rules={[{ required: true, message: t("createLiquidity.pleaseEnterInitialPrice") }]}>
                <Input disabled placeholder={t("createLiquidity.pleaseEnterInitialPrice")} suffix={Object.keys(basicInfo1).length > 0 && Object.keys(basicInfo2).length > 0 && <>{basicInfo1.symbol + " 每 " + basicInfo2.symbol}</> || <></>}></Input>
              </Form.Item>
              {/* {basicInfo1.symbol && basicInfo2.symbol && initPrice && <>预估价格范围：{Number(Number(initPrice * 0.9).toFixed(9))} - {Number(Number(initPrice * 1.1).toFixed(9))} {basicInfo1.symbol} 每 {basicInfo2.symbol}</>} */}
            </div>
            <div className="input-section">
              {/* 费率层级 */}
              <div className="input-title">{t("createLiquidity.feeTier")}</div>
              {/* 请费率层级 */}
              <Form.Item name="feeRate" rules={[{ required: true, message: t("createLiquidity.pleaseSelectFeeTier") }]}>
                <Select
                  // defaultValue="lucy"
                  placeholder={t("createLiquidity.pleaseSelectFeeTier")}
                  style={{ width: "100%" }}
                  onChange={() => { }}
                  options={Object.values(TickFeeRate).map((item: any) => ({
                    value: Number(item.tickSpacing),
                    // 不存在
                    label: <>{item.feePeople} {!item.isExiting && <> ({t("addLiquidity.notExist")})</>}</>,
                    disabled: !item.isExiting
                  }))}
                />
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="input-section">
              {/* 加池数量 */}
              <div className="input-title">{t("createLiquidity.addAmount")} {Object.keys(basicInfo1).length > 0 && <span>({basicInfo1.symbol})</span>}</div>
              {/* 请输入加池数量 */}
              <Form.Item name="token1Amount" rules={[{ required: true, message: t("createLiquidity.pleaseEnterAddAmount") }]}>
                <Input placeholder={t("createLiquidity.pleaseEnterAddAmount")} className="cus-ipt"></Input>
              </Form.Item>
              <div className="balance-section">
                <div className="balance">{t("createLiquidity.balance")}：{balanceFun1()}</div>
                <div className="ratio-options">
                  <div className="item" onClick={() => { setToken1Amount(2) }}>20%</div>
                  <div className="item" onClick={() => { setToken1Amount(5) }}>50%</div>
                  <div className="item" onClick={() => { setToken1Amount(8) }}>80%</div>
                  <div className="item" onClick={() => { setToken1Amount(10) }}>100%</div>
                </div>
              </div>
            </div>
            <div className="input-section">
              {/* 加池数量 */}
              <div className="input-title">{t("createLiquidity.addAmount")} {Object.keys(basicInfo2).length > 0 && <span>({basicInfo2.symbol})</span>}</div>
              <Form.Item name="token2Amount" rules={[{ required: true, message: t("createLiquidity.pleaseEnterAddAmount") }]}>
                <Input placeholder="-" className="cus-ipt" disabled></Input>
              </Form.Item>
              <div className="balance-section">
                {/* 余额 */}
                <div className="balance">{t("createLiquidity.balance")}：{balanceFun2()}</div>
                <div className="ratio-options">
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>

      <Alert
        message={
          <div>
            {hintMessage}
          </div>
        }
        type="warning"
        showIcon
        closable
        className="cus-alert"
      />
      {/* 创建流动性 */}
      {!isCreating && <button className="start-btn" onClick={start}>{t("createLiquidity.create")}</button>}
      {isCreating && <button className="start-btn" onClick={start}>
        <Loader>
          <img src={cdnUrl("/img/loading-white.png")} alt="" />
        </Loader>
        {/* 创建流动性中... */}
        {t("createLiquidity.creating")}
      </button>}
      <div className="charge-hint">
        {/* 全网最低服务费，仅需 {formatUnits(FEE_ADDRESS.sui.createLiquidity.serviceFee, 9)} SUI */}
        {t("createLiquidity.lowestServiceFee", { number: formatUnits(serviceFee, 9) })}
      </div>

      {/* 流动性创建成功 */}
      <MyModal isOpen={isSuccessModalOpen} setIsOpen={setIsSuccessModalOpen} title={t("addLiquidity.addSuccess")} img={cdnUrl("/img/check-circle-filled.png")} wrapClassName='create-liquidity-success-modal'>
        {/* 代币地址 */}
        <div className='logo-section'>
          <div>
            <img className='logo-img' src={isSuiCoinType(basicInfo1.coinType) ? cdnUrl("/img/chains/sui.svg") : basicInfo1.iconUrl} alt="" />
            <img className='logo-img' style={{ position: "relative", left: "-8px" }} src={basicInfo2.iconUrl} alt="" />
          </div>
          <div className='minted-amount'>
            {/* 已创建流动性池 */}
            <div>{t("createLiquidity.poolCreated")} {basicInfo1.symbol}/{basicInfo2.symbol}</div>
          </div>
          <div className='name-and-symbol'>1 {basicInfo1.symbol} ≈ {Number(token2Amount / token1Amount).toFixed(4)} {basicInfo2.symbol}</div>
        </div>
        <div className='info-section'>
          <div className='item'>
            {/* 数量 */}
            <div className='left'> {basicInfo1.symbol}{t("createLiquidity.amount")}</div>
            <div className='right'>{token1Amount}</div>
          </div>
          <div className='item'>

            {/* 数量 */}
            <div className='left'> {basicInfo2.symbol}{t("createLiquidity.amount")}</div>
            <div className='right'>{token2Amount}</div>
          </div>
          <div className='item'>
            <div className='left'>HASH</div>
            <div className='right'>
              <div style={{ color: "#0063F7", cursor: "pointer" }} onClick={() => {
                window.open(`https://suivision.xyz/txblock/${hash}`)
              }}>{formatAddress(hash)}</div>
              <img src={cdnUrl("/img/999999copy.svg")} onClick={() => {
                copy(hash)
              }} alt="" />
            </div>
          </div>
        </div>
        <div className='btns'>
          {/* 关闭 */}
          <button className='first-btn' onClick={() => {
            setIsSuccessModalOpen(false)
          }}>{t("tokenCreation.close")}</button>
          {/* 去链上查看 */}
          <button className='second-btn' onClick={() => {
            window.open(`https://suivision.xyz/txblock/${hash}`)
          }}> {t("tokenCreation.viewOnChain")}</button>
        </div>
      </MyModal>
      {/* 失败框 */}
      <MyModal
        // title="添加流动性失败"
        title={t("addLiquidity.addFailed")}
        img={cdnUrl("/img/fail.webp")}
        isOpen={isErrorModalOpen}
        setIsOpen={setIsErrorModalOpen}
      >
        <div className="error-modal-section">
          <div className="row1">
            {/* 温馨提示，中转转账可能失败的原因如下： */}
            {t("IntermediaryTransfer.failReasonTitle")}：
          </div>
          <div className="reason">
            <div>
              {/* 1. BSC链上拥堵，请稍后再试。 */}
              1. {t("IntermediaryTransfer.reason1")}。
            </div>
            <div>2. {t("IntermediaryTransfer.reason2")}</div>
          </div>
          <div className="resolve">
            {/* 您可以将生成的地址文件导入 */}
            {t("IntermediaryTransfer.importFile")}
            {/* 批量查询余额 */}
            <span> {t("IntermediaryTransfer.batchQuery")}</span>
            {/* 功能中，查看资产所在钱包地址。 如果您仍无法找到解决方案，请联系 */}
            {t("IntermediaryTransfer.contactSupport")}
            {/* 官方客服 */}
            <span> {t("IntermediaryTransfer.officialSupport")}</span>
            {/* 以获取帮助。 */}
            {t("IntermediaryTransfer.getHelp")}
          </div>
          <div className="eorrorModal-btns">
            <button
              className="close-btn"
              onClick={() => {
                setIsErrorModalOpen(false);
              }}
            >
              {/* 关闭 */}
              {t("IntermediaryTransfer.close")}
            </button>
            <button
              className="retry-btn"
              onClick={() => {
                setIsErrorModalOpen(false);
              }}
            >
              {/* 再试一次 */}
              {t("IntermediaryTransfer.retry")}
            </button>
          </div>
        </div>
      </MyModal>
      {/* <button onClick={() => { setIsSuccessModalOpen(true) }}>chenggong</button> */}
    </div >
  );
}
